export default __webpack_public_path__ + "static/media/Quiken_Motocicleta-16.95cba81b.svg";